/**
 * @generated SignedSource<<1289d176ce51b881c26c01ad91997323>>
 * @relayHash 36e216c364499688816cc4962830ad71
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 36e216c364499688816cc4962830ad71

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BloodChemistry = "ALBUMIN" | "ALK_PHOSPHOTASE" | "AMYLASE" | "BILIRUBIN" | "BLOOD_SUGAR" | "CHLORIDE" | "CHOLSTEROL" | "CHOLSTEROL_HDL" | "CK" | "CREATININE" | "CRP" | "GAMMA_GT" | "GOT_ASAT" | "GPT_ALAT" | "HDL" | "LDH" | "NT_PRO_BNP" | "PHOSPHATE" | "POTASSIUM" | "SODIUM" | "TRIGLYCERIDE" | "TROPONIN_T" | "UREA" | "URIC_ACID";
export type Coagulation = "D_DIMER" | "INR" | "QUICK";
export type Hematology = "HAEMOGRAM_II" | "HAEMOGRAM_V" | "HBA1_C";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type RapidTest = "COVID19" | "LACTOSE_INTOTERANCE" | "STREP_A";
export type UrineDiagnostic = "BETA_HCG" | "MICROALBUMIN" | "STIX_SEDIMENT" | "URICULT";
export type Ch_updateMeasLaboratoryPrescriptionInput = {
  bloodChemistries: ReadonlyArray<BloodChemistry>;
  coagulations: ReadonlyArray<Coagulation>;
  hematologies: ReadonlyArray<Hematology>;
  id: string;
  language: Language;
  rapidTests: ReadonlyArray<RapidTest>;
  urineDiagnostics: ReadonlyArray<UrineDiagnostic>;
};
export type useChUpdateMeasLaboratoryPrescriptionMutation$variables = {
  input: Ch_updateMeasLaboratoryPrescriptionInput;
};
export type useChUpdateMeasLaboratoryPrescriptionMutation$data = {
  readonly ch_updateMeasLaboratoryPrescription: {
    readonly ch_MeasLaboratoryPrescription: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"chMeasLaboratoryPrescriptionFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChUpdateMeasLaboratoryPrescriptionMutation = {
  response: useChUpdateMeasLaboratoryPrescriptionMutation$data;
  variables: useChUpdateMeasLaboratoryPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChUpdateMeasLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateMeasLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_updateMeasLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasLaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasLaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "chMeasLaboratoryPrescriptionFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChUpdateMeasLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updateMeasLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_updateMeasLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasLaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasLaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentFileMetadata",
                "kind": "LinkedField",
                "name": "fileMetadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lengthInKilobytes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bloodChemistries",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "coagulations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hematologies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urineDiagnostics",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rapidTests",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "36e216c364499688816cc4962830ad71",
    "metadata": {},
    "name": "useChUpdateMeasLaboratoryPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8db323448970c6f308c1dac916405d26";

export default node;
